import React, { useMemo } from "react";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { Autocomplete, Button, ButtonProps, Popover, TextField, TextFieldProps } from "@mui/material";

import "./Filters.styles.scss";
import { useManagersSelect, useTaskDealsSelect } from "store";
import { DealBase, TaskDueDates, TaskQueries, TaskStatus, UserLight } from "store/types";
import { taskDueDates, taskStatusOptions } from "../../../constants";
import { useDealParamsHooks } from "hooks";

const renderOption = (props: React.HTMLAttributes<HTMLLIElement>, option: Partial<any>) => {
  return (
    <li {...props} key={option.id}>
      {option.label}
    </li>
  );
};

const commonInputPtops: {
  sx?: TextFieldProps["sx"];
  size: TextFieldProps["size"];
  InputLabelProps: TextFieldProps["InputLabelProps"];
} = {
  // sx: {
  //   ".MuiOutlinedInput-root": {
  //     width: "310px",
  //   },
  // },
  size: "small",
  InputLabelProps: { shrink: true }
};
interface IFiltersProps {
  updateQueries: (data: Partial<TaskQueries>) => void;
  deal: TaskQueries["deal"];
  status: TaskQueries["status"];
  due_date: TaskQueries["due_date"];
  assignee: TaskQueries["assignee"];
  triggerStyles?: ButtonProps["sx"];
}

export const Filters: React.FC<IFiltersProps> = ({ updateQueries, triggerStyles = {}, ...rest }) => {
  const { deal, status, due_date, assignee } = rest;
  const deals = useTaskDealsSelect();
  const assignees = useManagersSelect();
  const { dealId } = useDealParamsHooks();

  const isFiltersSelected: boolean = useMemo(() => {
    return !!Object.values({ ...rest, deal: !dealId ? deal : null }).filter(Boolean).length;
  }, [rest, dealId, deal]);

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  return (
    <div className="filters">
      <Button
        sx={{ ...triggerStyles, backgroundColor: isFiltersSelected ? "#dae0e2" : "transparent" }}
        onClick={handleClick}
        variant="outlined"
        size="sm"
        startIcon={<FilterAltIcon />}
      >
        Filters
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        sx={{ overflow: "hidden" }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left"
        }}
      >
        <div className="task-filters-popup">
          {!dealId && (
            <Autocomplete
              disableCloseOnSelect
              options={deals}
              value={deal}
              multiple
              getOptionLabel={(option) => option.title}
              renderOption={(props: React.HTMLAttributes<HTMLLIElement>, option: DealBase) => (
                <li {...props} key={option.id}>
                  {option.title}
                </li>
              )}
              onChange={(_, option) => updateQueries({ deal: [...option] })} // TS issue
              renderInput={(params) => <TextField {...params} {...commonInputPtops} label="Deal" />}
            />
          )}
          <Autocomplete
            disableCloseOnSelect
            options={assignees}
            value={assignee}
            multiple
            renderOption={(props: React.HTMLAttributes<HTMLLIElement>, option: UserLight) => (
              <li {...props} key={option.id}>
                {option.full_name}
              </li>
            )}
            onChange={(_, option) => updateQueries({ assignee: [...option] })} // TS issue
            getOptionLabel={(option) => option.full_name}
            renderInput={(params) => <TextField {...params} {...commonInputPtops} label="Assignee" />}
          />
          <Autocomplete<
            {
              label: string;
              value: TaskStatus;
            },
            true
          >
            disableCloseOnSelect
            options={taskStatusOptions}
            value={status}
            multiple
            renderOption={renderOption}
            onChange={(_, option) => updateQueries({ status: [...option] })} // TS issue
            renderInput={(params) => <TextField {...params} {...commonInputPtops} label="Status" />}
          />
          <Autocomplete<{ label: string; value: TaskDueDates }, true>
            disableCloseOnSelect
            options={taskDueDates}
            value={due_date}
            multiple
            renderOption={renderOption}
            onChange={(_, option) => updateQueries({ due_date: [...option] })} // TS issue
            renderInput={(params) => <TextField {...params} {...commonInputPtops} label="Due Date" />}
          />
        </div>
      </Popover>
    </div>
  );
};
